"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.constants = void 0;
var constants = {
  TWITTER_URL: 'https://twitter.com/bagonboard',
  FACEBOOK_URL: 'https://www.facebook.com/bagonboard/',
  INSTAGRAM_URL: 'https://www.instagram.com/bob.io_/',
  LINKEDIN_URL: 'https://www.linkedin.com/company/bagonboard/'
};
exports.constants = constants;